/**
 * 路线设置页懒加载壳（14.39b；MyPrivacyLazy 同构）：低频页不进首屏 bundle。
 * （登录页的内联开关行走 useRouteSwitch，那份逻辑本就在首屏，与本壳无关。）
 */
import { useLazyModule } from './useLazyModule';

export function RouteSettingsLazy() {
  const { mod } = useLazyModule(() => import('./RouteSettingsPage'));
  if (mod === null) return <div data-testid="route-settings-loading-shell">加载中…</div>;
  return <mod.RouteSettingsPage />;
}
